import { cn } from '@simplywallst/ui-core/next';

export const Bones = ({ className }: { className?: string }) => (
  <span
    className={cn(
      'block h-auto w-full animate-pulse rounded-md bg-surface-2',
      className
    )}
  >
    {/* Zero whitespace character (avoid layout shift) */}
    &#8203;
  </span>
);
